<div
  class="sidebar fixed top-0 left-0 h-[100vh] w-[78px] p-[6px_6px] z-[20] bg-white transition-all duration-500 ease-in-out"
  [class.open]="sidebarService.isOpen()" >
  <div class="logo_details h-[60px] flex items-center relative">
    <img class="logo_name" src="/assets/images/tamiin-logo-greenblack.svg" alt="Logo" />

   <span (click)="sidebarService.toggle()" id="btn" style="cursor: pointer;">
  <i *ngIf="!sidebarService.isOpen()" class="bx bx-menu mr-4"></i>
  <img *ngIf="sidebarService.isOpen()" src="/assets/icons/close_menu.svg" alt="Menu Open" class="w-[20px] h-[20px]" />
</span>
  </div>
  <div class="relative side-box">
    <div class="nav-container">
      <ul *ngFor="let item of navItems" class="nav-list">
        <!-- <li>
          <i class="bx bx-search" (click)="toggleSidebar()"></i>
          <input type="text" placeholder="Search...">
          <span class="tooltip">Search</span>
        </li> -->
        <li class="nav-item">
          <div>
            <!-- If the item has NO submenu, use routerLink -->
            <a *ngIf="!item.submenu; else hasSubmenu" [routerLink]="item.link" class="link-box"
              [class.sub-active]="isActive(item, 'menu')" (click)="toggleSidebarIfMobile()">
              <div class="flex items-center">
                <ng-container *ngIf="item.isMaterialIcon; else customIcon">
                  <i class="material-symbols-outlined">{{ item.icon }}</i>
                </ng-container>
                <ng-template #customIcon>
                  <i [class]="item.icon"></i>
                </ng-template>
                <span class="link_name">{{ item.name }}</span>
              </div>
            </a>

            <!-- If the item HAS a submenu, disable click -->
            <ng-template #hasSubmenu>
              <a class="link-box disabled-link" (click)="toggleMenu(item)" [attr.aria-expanded]="isSubmenuActive(item)">
                <div class="flex items-center">
                 <ng-container *ngIf="item.isMaterialIcon; else customIcon">
                  <i class="material-symbols-outlined">{{ item.icon }}</i>
                </ng-container>
                <ng-template #customIcon>
                  <i [class]="item.icon"></i>
                </ng-template>
                  <span class="link_name">{{ item.name }}</span>
                </div>
                <i class="bx down" [ngClass]="{
                    'bx-chevron-down': isSubmenuActive(item),
                    'bx-chevron-right': !isSubmenuActive(item),
                  }"></i>
              </a>
            </ng-template>
          </div>
          <!-- Submenu -->
          <ul *ngIf="item.submenu" class="submenu" [class.act]="isSubmenuActive(item)">
            <li *ngFor="let subItem of item.submenu">
              <a [routerLink]="subItem.link" [class.sub-active]="isActive(subItem, 'submenu')" (click)="toggleSidebarIfMobile()">
                 <ng-container *ngIf="subItem.isMaterialIcon; else customIcon">
                  <i class="material-symbols-outlined">{{ subItem.icon }}</i>
                </ng-container>
                <ng-template #customIcon>
                  <i [class]="subItem.icon"></i>
                </ng-template>
                <span class="link_name sub_link_name">{{ subItem.name }}</span>
              </a>
              <span class="tooltipsub">{{ item.name }}/{{ subItem.name }}</span>
            </li>
          </ul>

          <span *ngIf="!item.submenu" class="tooltipMain">{{ item.name }}</span>

        </li>
      </ul>
    </div>
  </div>
</div>

<div class="media-restrict" *ngIf="sidebarService.isOpen()" (click)="sidebarService.toggle()"></div>